// extracted by mini-css-extract-plugin
module.exports = {"campaignBanner":"CampaignBanner_campaignBanner___nQ8A","mobile":"CampaignBanner_mobile__o6Zeg","desktop":"CampaignBanner_desktop__GQ_tV"};